import { merge } from 'ramda';

export const UPDATE_SERVICEWORKER = 'UPDATE_SERVICEWORKER';
export const DISMISS = 'DISMISS_SERVICE_WORKER_UPDATE';

export const updateServiceWorker = () => ({
  type: UPDATE_SERVICEWORKER
});

export const dismissUpdateHook = () => ({ type: DISMISS });

const initialState = {
  hasUpdate: false
};

const serviceWorkerReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SERVICEWORKER:
      return merge(state, { hasUpdate: true });
    case DISMISS:
      return merge(state, { hasUpdate: false });
    default:
      return state;
  }
};

export default serviceWorkerReducer;
